import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1a99002"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-md-12 px-1 py-3 border-bottom"
}
const _hoisted_2 = { class: "row my-3 justify-content-center" }
const _hoisted_3 = { class: "col-md-12 pt-4" }
const _hoisted_4 = { class: "p-4 mb-4 bg-card-light border-radius-10 h-100" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-between mb-2" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-14" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Documents")
    ])
  ])
], -1))
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = { class: "col-md-12 table-responsive" }
const _hoisted_10 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Document Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Date Added"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_12 = { class: "exA" }
const _hoisted_13 = { class: "exA" }
const _hoisted_14 = { class: "exA" }
const _hoisted_15 = { class: "exA" }
const _hoisted_16 = ["id", "value"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"18px","color":"#005288","font-weight":"bolder","writing-mode":"vertical-rl","text-orientation":"sideways","margin-top":"15px"},
  class: "p-cursor dropdown-toggle",
  id: "datatoggle",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " ... ", -1))
const _hoisted_18 = {
  class: "dropdown-menu",
  "aria-labelledby": "datatoggle"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center"
}, "No Records", -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!

  return (_ctx.fum_id!='')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_basic, { myinv_id: _ctx.myinv_id }, null, 8, ["myinv_id"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("input", {
                    onKeyup: _cache[0] || (_cache[0] = ($event: any) => {_ctx.textSearch($event);}),
                    style: {"border":"1px solid grey !important","height":"35px","float":"right","border-radius":"5px !important"},
                    type: "text",
                    id: "doc_search_input",
                    placeholder: "Search doc name here..",
                    class: "bg-white w-100 pl-3"
                  }, null, 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "main_securities",
                          key: doc.doc_id
                        }, [
                          _createElementVNode("td", _hoisted_12, _toDisplayString(doc.doc_id), 1),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(doc.doc_name), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(doc.doc_time), 1),
                          _createElementVNode("td", _hoisted_15, [
                            _createElementVNode("input", {
                              id: 'URL'+doc.doc_id,
                              type: "hidden",
                              value: doc.doc_url
                            }, null, 8, _hoisted_16),
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("a", {
                                class: "dropdown-item pl-2",
                                onClick: ($event: any) => {_ctx.open_link(doc.doc_id);},
                                href: "#"
                              }, " • Download", 8, _hoisted_19)
                            ])
                          ])
                        ]))
                      }), 128)),
                      (!_ctx.docs.length)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}